const feedback = state => state.common.feedback ?? null

export { feedback }
